import React, { FunctionComponent } from 'react';

export interface ValueOrDashProps {
  value: string | number | null;
}

export const ValueOrDash: FunctionComponent<ValueOrDashProps> = props => {
  return <>{props.value ? props.value : '—'}</>;
};
